/* @flow weak */
import React from 'react';
import Link from 'components/Link.jsx';
import cx from 'classnames';

class MailTo extends React.Component {
  static propTypes = {
    to: React.PropTypes.string,
    subject: React.PropTypes.string,
    body: React.PropTypes.string,
    bcc: React.PropTypes.string,
  };

  static defaultProps = {
    to: '',
    subject: '',
    body: '',
    cc: '',
    bcc: '',
  };

  getMailProps = () => {
    let props = [];
    const otherProps = ['subject', 'body', 'cc', 'bcc'];

    for (const p in this.props) {
      if (otherProps.indexOf(p) > -1 && this.props[p]) {
        props.push(`${p}=${this.getProp(p)}`);
      }
    }

    props = props.join('&');
    return props;
  };

  getMailToLink = () => {
    return 'mailto:' + this.getTo() + '?' + this.getMailProps();
  };

  getProp = (prop) => {
    return encodeURIComponent(this.props[prop]);
  };

  getTo = () => {
    return this.props.to || '';
  };

  renderBody = () => {
    let body;

    if (this.props.children) {
      body = this.props.children;
    } else {
      body = this.getTo();
    }

    return body;
  };

  render() {
    const { to, ...other } = this.props; // eslint-disable-line no-unused-vars

    const mailto = (
      <Link
        {...other}
        className={cx(
          'MailTo',
          this.props.className
        )}
        href={this.getMailToLink()}
        target="_blank">
        {this.renderBody()}
      </Link>
    );

    return mailto;
  }
}

export default MailTo;



// WEBPACK FOOTER //
// ./src/components/MailTo.jsx